<template>
  <div class="services" v-scroll-reveal="{ delay: 200 }">
    <video autoplay playsinline muted loop preload>
      <source
        src="https://player.vimeo.com/external/334285487.hd.mp4?s=d602982a8ee81aad3fc67f517a81ccf12a662ddb&profile_id=175"
      />
    </video>
    <div class="container">
      <h2 v-scroll-reveal>
        From pre-launch to re-launch.<br />This is what we do.
      </h2>
      <div class="row">
        <div class="quarter" v-scroll-reveal="{ delay: 100 }">
          <h3>Strategy</h3>
          <p>
            Our roadmap-driven process focuses work between stakeholder and
            producer, from start to finish.
          </p>
        </div>
        <div class="quarter" v-scroll-reveal="{ delay: 200 }">
          <h3>Insights</h3>
          <p>
            We'll introduce you to your customer. User perspective lays the
            foundation for successful changes.
          </p>
        </div>
        <div class="quarter" v-scroll-reveal="{ delay: 300 }">
          <h3>Design</h3>
          <p>
            Brand and experience design in a digital world that users love.
          </p>
        </div>
        <div class="quarter" v-scroll-reveal="{ delay: 400 }">
          <h3>Tech</h3>
          <p>
            Innovation drives us, solutions follow us. We build for tomorrow in
            an ever-changing world.
          </p>
        </div>
      </div>
      <p v-if="showMore" class="op1" v-scroll-reveal>
        <router-link to="/services">
          Find out more about us →
        </router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Services",
  props: {
    header: String,
    showMore: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./src/assets/css/typography.scss";
.services {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;

  position: relative;
  overflow: hidden;
  //background:blue;
  video {
    display: none;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    object-fit: cover;
    opacity: 0.5;
    transition: opacity 0.5s ease-in-out;
    //mix-blend-mode: exclusion;
    //filter:blur(10px);
  }
  .container {
    width: 100%;
    flex-shrink: 0;
    > h2 {
      @include headline-small;
      width: 50%;
      padding-right: 3vw;
      margin-bottom: 10vh;
    }
    .row {
      display: flex;
      width: 100%;
      flex-shrink: 0;
      //display: none;
      .quarter {
        width: 25%;
        flex-shrink: 0;
        padding-right: 5vw;
        //text-align: center;
        h3 {
          @include headline-medium;
          position: relative;
          display: inline-block;
          &:before {
            content: "";
            position: absolute;
            font-size: 0.7vw;
            letter-spacing: 0;
            top: -4vh;
            left: 0;
            border-radius: 1.5vh;
            border: 1px solid white;
            width: 1.5vw;
            line-height: 1.5vw;
            text-align: center;
            background: $black;
            box-shadow: 0 0 0 5px rgba($black, 0.05);
            //color:white !important;
          }
        }
        &:nth-child(1) {
          h3:before {
            content: "01";
            color: $green;
            border-color: $green;
          }
        }
        &:nth-child(2) {
          h3:before {
            content: "02";
            color: $yellow;
            border-color: $yellow;
          }
        }
        &:nth-child(3) {
          h3:before {
            content: "03";
            color: $pink;
            border-color: $pink;
          }
        }
        &:nth-child(4) {
          h3:before {
            content: "04";
            color: $blue;
            border-color: $blue;
          }
        }
      }
    }
    a {
      //color:white;
      text-decoration: none;
    }
  }
}
@media (max-width: $mobile) {
  .services {
    .container {
      > h2 {
        width: 100%;
      }
      .row {
        flex-direction: column;
        .quarter {
          width: 100%;
          margin-bottom: 50px;
          h3 {
            &:before {
              font-size: 10px;
              top: -34px;
              left: 0;
              border-radius: 20px;
              border: 1px solid white;
              width: 20px;
              line-height: 20px;
              text-align: center;
            }
          }
        }
      }
    }
  }
}
</style>
